/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";

// Material Dashboard 2 React Context Providers
import { MaterialUIControllerProvider, CimbeoProvider } from "./context";

const queryClient = new QueryClient();

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <CimbeoProvider>
          <App />
        </CimbeoProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
